module.exports = __webpack_public_path__ + "img/hospital@2x.84c586f6.png";